import CachedIcon from '@mui/icons-material/Cached';
import { Card, CardContent, CardHeader, IconButton, Typography } from "@mui/material";
import * as React from "react";
import { Cpn4GLteSettingModel, UpdateResult } from '../../../models';

import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import CircularProgress from '@mui/material/CircularProgress';
import { connect } from "react-redux";
import { actionCreators, ApplicationState, FetchState, selectors } from "../../../store";
import { showUnit } from '../../../utils';
import Select4GLteSettingDialog from '../../dialogs/Select4GLteSettingDialog';
import FetchHelper from '../../FetchHelper';
import { disabledRefreshAllBtnStyle, disabledRefreshSuccessIconStyles, enableRefreshAllBtnStyle, enableRefreshSuccessIconStyles, pollingColStyle, pollingColStyleTitle } from '../../styles';

const NO_OF_POLLING_TOPIC = 16;

const params = {
    mainid: "",
    isRefreshAllBegin: 0,
    loadingRefreshAll: [false],
    isEdit: false,
    isRefreshGroup: false,
    isDisbleRefeshBtn: true,
    isDisbleUpdateBtn: true,
    isRefreshAllCompleted: (status: number) => { },
    setIsEdit: (isEdit: boolean) => { },
    setRefreshGroup: (disabled: boolean, name: string) => { },
    setDisabledRefreshGroupBtn: (disabled: boolean, name: string) => { },
}
const fetchId = "DATA_4G_LTE_SETTING_FETCH";

type Cpn4GLteSettingProps = {
    defaultData: Cpn4GLteSettingModel | undefined;
    deviceNo?: string;
    centralId?: string;
    isRefreshSuccessDeviceNo?: boolean;
    onRefreshComplete?: () => void;
};

export type PureCpn4GLteSettingProps = Cpn4GLteSettingProps & ReturnType<typeof mapStateToProps> &
    typeof mapDispatchToProps & typeof params;

export const Cpn4GLteSetting_TJ360VersionDevice = (props: PureCpn4GLteSettingProps) => {
    const { defaultData, fetchState, mainid, isRefreshAllBegin, loadingRefreshAll, isEdit, isRefreshGroup, isDisbleRefeshBtn, isDisbleUpdateBtn, deviceNo, centralId, isRefreshSuccessDeviceNo } = props;
    const { onError, onUpdate, onRefresh, onUpdateSuccess, onUpdateError, isRefreshAllCompleted, setIsEdit, setRefreshGroup, setDisabledRefreshGroupBtn } = props;
    const [openSelectDialog, setOpenSelectDialog] = React.useState(false);
    const [updateData, setUpdateData] = React.useState<any>();
    const [data4GLteSetting, setData4GLteSetting] = React.useState<Cpn4GLteSettingModel|null>(fetchState.data);
    const [editData, setEditData] = React.useState<Cpn4GLteSettingModel>();
    const [fetchLoading, setFetchLoading] = React.useState(false);
    const [editFlg, setEditFlg] = React.useState(false);
    const [isFetchAll, setIsFetchAll] = React.useState(false);
    const [isRefreshSuccess, setIsRefreshSuccess] = React.useState(false);

    React.useEffect(() => {
        if(!isRefreshSuccessDeviceNo)
            setIsRefreshSuccess(false);
    }, [isRefreshSuccessDeviceNo]);

    // パラメータ設定
    const handleFetchParams = () => {
        const params = new Map<string, any>();
        const code = "QL";
        params.set("code", code);
        params.set("mainid", mainid);
        params.set("device_no", deviceNo);
        params.set("centralid", centralId);
        return params;
    }

    const handleFetchSuccess = (data: any, action: string, isClickedRefreshBtn: boolean) => {
        const resData = {
            mainid: data.mainid,
            deviceNo: data.device_no,
            serverIpAddr: data.server_ip_addr,
            serverPort: data.server_port,
            modemIpAddr: data.modem_ip_addr,
            modemPort: data.modem_port,
            serverTime: data.server_time,
            ackTime: data.ack_time,
            lastGetDatetime: data.last_get_datetime,
        } as Cpn4GLteSettingModel;

        setData4GLteSetting(resData);
        setFetchLoading(false);
        setIsFetchAll(false);
        isClickedRefreshBtn && setIsRefreshSuccess(true);
        loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] = false;
        setRefreshGroup(false, fetchId);

        if (action === 'edit') {
            setEditData(resData);
            setOpenSelectDialog(true);
        }
    };

    const handleError = (success: boolean, data: any, error: any) => {
        onError(success, data, error);
        setEditFlg(false);
        setFetchLoading(false);
        setIsFetchAll(false);
        setIsRefreshSuccess(false);
        loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] = false;
        setRefreshGroup(false, fetchId);
    }

    const handleRefresh = () => {
        setFetchLoading(true);
        setIsRefreshSuccess(false);
        const params = handleFetchParams();
        onRefresh(params, fetchId + deviceNo);
    };

    const handleRefreshSuccess = (data: any) => {
        editFlg ? handleFetchSuccess(data, 'edit', true) : handleFetchSuccess(data, 'view', true);
        props.onRefreshComplete?.();
    }

    const [updateDialogTitle, setUpdateDialogTitle] = React.useState('');

    const handleUpdateOk = (request: any) => {
        setOpenSelectDialog(false);
        const code = "QM";
        const requestData = {
            mainid: request.mainid,
            device_no: request.device_no,
            server_ip_addr: request.server_ip_addr,
            server_port: request.server_port,
            modem_ip_addr: request.modem_ip_addr,
            modem_port: request.modem_port,
            server_time: request.server_time,
            ack_time: request.ack_time,
        }
        onUpdate(code, mainid, requestData);
        setUpdateData(request);
        setFetchLoading(true);
        setIsRefreshSuccess(false);
    };

    const handleUpdateCancel = () => {
        setOpenSelectDialog(false);
    };

    const handleUpdateSuccess = (success: boolean, data: any, error: any) => {
        const result = {
            mainid: data.mainid,
            deviceNo: data.device_no,
            resultCode: data.result_code,
        } as UpdateResult;
        if (result.resultCode === '0') {
            handleFetchSuccess(updateData, 'view', true);
            onUpdateSuccess();
        } else {
            handleUpdateError(success, data, error);
        }
    }

    const handleUpdateError = (success: boolean, data: any, error: any) => {
        setFetchLoading(false);
        setIsRefreshSuccess(true);
        onUpdateError(success, data, error);
    }

    const refreshAll = () => {
        if (isRefreshAllBegin === NO_OF_POLLING_TOPIC || isRefreshGroup === true) {
            handleRefresh();
        }
        if (loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] === true) {
            setFetchLoading(true);
            setIsRefreshSuccess(false);
        }
        isRefreshAllBegin > 0 || isRefreshGroup ? setIsFetchAll(true) : setIsFetchAll(false);
    }
    // eslint-disable-next-line
    React.useEffect(refreshAll, [isRefreshAllBegin, loadingRefreshAll, isRefreshGroup]);

    const handleDisabledRefreshAll = () => {
        if (!fetchLoading) {
            setDisabledRefreshGroupBtn(false, fetchId);
        } else {
            setDisabledRefreshGroupBtn(true, fetchId);
        }
    }
    // eslint-disable-next-line
    React.useEffect(handleDisabledRefreshAll, [fetchLoading]);

    React.useEffect(() => {
        editFlg ? setIsEdit(true) : setIsEdit(false);
        // eslint-disable-next-line
    }, [editFlg])

    React.useEffect(() => {
        defaultData && handleFetchSuccess(defaultData, 'view', false);
        if(!defaultData) {
            setData4GLteSetting(null);
        }
        // eslint-disable-next-line
    }, [defaultData]);

    return (
        <>
            <Card style={{ margin: '0 auto 12px', backgroundColor: '#f5faff', width: '100%' }}>
                <CardHeader
                    avatar={
                        <PublishedWithChangesIcon style={isRefreshSuccess ? enableRefreshSuccessIconStyles : disabledRefreshSuccessIconStyles} />
                    }
                    action={
                        <div>
                            <IconButton aria-label="refresh" onClick={() => handleRefresh()} disabled={isDisbleRefeshBtn || editFlg || fetchLoading || isFetchAll}>
                                <CachedIcon fontSize="medium" style={isDisbleRefeshBtn || editFlg === true || fetchLoading || isFetchAll ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                            </IconButton>
                        </div>
                    }
                    title='4G LTE設定'
                    titleTypographyProps={{ variant: 'h5' }}
                />
                <CardContent style={{ padding: '0 0 16px 0' }}>
                    {fetchLoading ? (
                        <div style={{ display: 'flex', position: 'relative' }}>
                            <table className='polling' style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                                <tbody>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Server IPアドレス</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Server ポート</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Modem IPアドレス</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Modem ポート</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>死活監視間隔</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>再送回数</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div style={{ position: 'absolute', top: '40%', left: '60%' }}>
                                <CircularProgress style={{ margin: 'auto' }} />
                            </div>
                        </div>
                    ) : (
                        <table className='polling' style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                            <tbody>
                                <tr>
                                    <td style={pollingColStyleTitle}>Server IPアドレス</td>
                                    <td style={pollingColStyle}>{data4GLteSetting?.serverIpAddr}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>Server ポート</td>
                                    <td style={pollingColStyle}>{data4GLteSetting?.serverPort}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>Modem IPアドレス</td>
                                    <td style={pollingColStyle}>{data4GLteSetting?.modemIpAddr}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>Modem ポート</td>
                                    <td style={pollingColStyle}>{data4GLteSetting?.modemPort}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>死活監視間隔</td>
                                    <td style={pollingColStyle}>{data4GLteSetting?.serverTime}{showUnit(data4GLteSetting?.serverTime, "時間")}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>再送回数</td>
                                    <td style={pollingColStyle}>{data4GLteSetting?.ackTime}{showUnit(data4GLteSetting?.ackTime, "回")}</td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                    <Typography display='flex' justifyContent='flex-end' padding='4px 4px 0 0'>最終取得日時：{data4GLteSetting?.lastGetDatetime ?? '-'}</Typography>
                </CardContent>
            </Card >
            {
                openSelectDialog ? (
                    <Select4GLteSettingDialog
                        isOpen={true}
                        onOK={(data) => handleUpdateOk(data)}
                        onCancel={handleUpdateCancel}
                        data={editData}
                        dialogTitle={updateDialogTitle}
                    />
                ) : (
                    <div />
                )
            }
            <FetchHelper fetchId={fetchId + deviceNo} onComplete={(success, data, error) => success ? handleRefreshSuccess(data) : handleError(success, data, error)} />
            <FetchHelper fetchId="UPDATE_DATA_4G_LTE_SETTING" method="POST" onComplete={(success, data, error) => success ? handleUpdateSuccess(success, data, error) : handleUpdateError(success, data, error)} />
        </>
    );
};
const mapStateToProps = (state: ApplicationState) => ({
    fetchState: selectors.getFetchState(
        state,
        fetchId
    ) as FetchState,
});
const mapDispatchToProps = {
    onUpdate: (code: string, mainid: string, data: any) => actionCreators.fetch("UPDATE_DATA_4G_LTE_SETTING", `/polling-nrf/set?code=${code}`, 'POST', data, false, true),
    onRefresh: (params: any, fetchId: string) => actionCreators.fetch(fetchId, `/polling-nrf/get`, "GET", params),
    onError: (success: boolean, data: any, error: any) =>
        actionCreators.showMessage({
            type: "error",
            title: `4G LTE設定取得`,
            body: "4G LTE設定取得できませんでした。",
        }),
    onUpdateSuccess: () =>
        actionCreators.showMessage({
            type: "info",
            title: `4G LTE設定変更`,
            body: "4G LTE設定を変更しました。",
        }),
    onUpdateError: (success: boolean, data: any, error: any) =>
        actionCreators.showMessage({
            type: "error",
            title: `4G LTE設定変更`,
            body: "4G LTE設定を変更できませんでした。",
        }),
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Cpn4GLteSetting_TJ360VersionDevice);
